import { NotFoundView } from '@not-found-current';

// Страница 404 / catch-all. Разметка у тем разная — за алиасом компонент
// (@not-found-current, выбор — NOT_FOUND в vite.config): у serious и wap
// иллюстрация темы, у telecom — знак TC в нуле на красной волне.
export function NotFound(props: { code?: number; message?: string }) {
  return <NotFoundView {...props} />;
}
